export const baseData = {
  title: "PRODUCT GROUP"
}